import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CustomerImportService } from 'OpsCenter/merchants/importing/customers/customer-import.service';

@Component({
  selector: 'app-customer-import',
  template: require('./customer-import.component.html'),
})
export class CustomerImportComponent {
  private merchantId: number = null;
  private fileToUpload: File = null;
  private importResponseMessages: string[] = [];
  private isLoading = false;

  @ViewChild('fileInput', {static: false})
  private fileInput: HTMLInputElement;

  constructor(private customerImportService: CustomerImportService, private notificationService: ToastrService) {}

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  uploadFile() {
    if (this.isLoading) {
      return;
    }

    this.enableLoading();
    this.importResponseMessages = [];
    this.customerImportService
      .uploadFile(this.merchantId, this.fileToUpload)
      .subscribe(res => this.handleUploadSuccess(res), res => this.handleUploadError(res));
  }

  private handleUploadSuccess(res) {
    const duplicatedRows = res['duplicates'];
    if (duplicatedRows && duplicatedRows.length) {
      this.importResponseMessages = [`Duplicated row(s): ${res['duplicates'].join(', ')}`];
    } else {
      this.importResponseMessages = ['All rows imported successfully'];
    }
    this.notificationService.success(`File ${this.fileToUpload.name} was successfully imported`);
    this.clearForm();
    this.disableLoading();
  }

  private handleUploadError(res) {
    this.importResponseMessages = res.error.errors.map(error => error.message);
    this.disableLoading();
  }

  private clearForm() {
    this.merchantId = null;
    this.fileToUpload = null;
    this.fileInput.value = '';
  }

  private enableLoading() {
    this.isLoading = true;
  }

  private disableLoading() {
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/importing/customers/customer-import.component.ts